/*
 * Contact Us | Book an Appointment Sticky CTA Handler
 */
import { utils } from './utils.js';

class Drawer {

    constructor() {
    }

    init() {
        let self    = this;
        let body    = this.body   = document.querySelector('body');
        let drawer  = this.drawer = document.querySelector('.drawer');
        if ( drawer == null ) {
            return;
        }
        this.ctaClicks();
        this.drawerClose();

        if ( matchMedia ) {
            // case when the centered modal was open then
            // the screen resized to lower resolution...
            const mq = window.matchMedia("(max-width: 640px)");
            mq.addListener( this.handleMe );
            this.handleMe(mq);
        }
    }

    handleMe(mq) {

        let self = this;
        let drawer  = document.querySelector('.drawer');
        if ( mq.matches ) {
            utils.removeClass( drawer, '-centered');
        } else {
            // console.log('Larger than 640px... add -centered as needed');
        }
    }

    resetDrawer() {
        let self = this;
        let body = this.body;
        let drawer = this.drawer;

        utils.removeClass( body, 'js-drawer-open' );
        utils.removeClass( drawer, '-open' );
        utils.removeClass( drawer, '-centered' );
        utils.removeClass( drawer, '-contact' );
        utils.removeClass( drawer, '-book' );
        var date = new Date(); var timestamp = date.getTime();
        // console.log('resetDrawer ' + timestamp);
    }

    ctaClicks() {
        let self    = this;
        let body    = this.body;
        let drawer  = this.drawer;
        let links   = document.querySelectorAll('.sticky-cta a');
        // Contact Us | Book an Appointment
        //
        Array.prototype.forEach.call(links, function(el, i) {
            // @todo if drawer already has these classes, skip
            //
            el.addEventListener('click', function(e) {
                e.preventDefault();

                self.resetDrawer();

                let targetClass = e.target.hash.substr(1);
                // e.g. -contact, -book
                //
                if ( targetClass == '-contact' ) {
                    // move the "cloned" community-card component into the drawer
                    let source      = document.querySelector('.right-content');    if ( source == null ) return;
                    let target      = document.querySelector('.drawer .-contact'); if ( target == null ) return;
                    let contactCard = source.querySelector('.contact-card');
                    var wrap        = document.createElement('div');
                        wrap.appendChild( contactCard.cloneNode(true) ); utils.addClass(wrap, '-contact');
                    target.parentNode.replaceChild( wrap, target );

                    // add a click handler after relocating the community-card
                    self.bookButton();
                }
                utils.addClass( body, 'js-drawer-open' );
                utils.addClass( drawer, '-open' );
                utils.addClass( drawer, targetClass );
            });
        });
    }

    drawerClose() {
        let self    = this;
        let body    = this.body;
        let drawer  = this.drawer;
        /**
         * handle close button click once the drawer is open
         */
        let drawerControl = document.querySelector('.drawer .control .js-drawer-menu');
        drawerControl.addEventListener('click', function(e) {
            e.preventDefault();
            self.resetDrawer();
        });
    }

    bookButton() {
        let self        = this;
        let body        = document.querySelector('body');
        let drawer      = this.drawer;

        let bookButton  = drawer.querySelector('.contact-card .contact-cta a');
        if ( bookButton != null ) {
            bookButton.addEventListener('click', function(e) {
                e.preventDefault();
                self.resetDrawer();
                utils.addClass( body, 'js-drawer-open' );
                utils.addClass( drawer, '-open' );
                utils.addClass( drawer, '-book' );
            });
        }
    }

}

// Singleton
export let drawer = new Drawer();